import type { WeekdayShortName } from "@@/shared/parse-weekly-schedule";
import type { WeekAvailability } from "./week-availability";

/**
 * Find all days in week with existing time ranges
 */
const daysWithAvailability = <Week extends WeekAvailability["week"]>(
    availability: Week
): Array<keyof Week> =>
    (Object.keys(availability) as WeekdayShortName[]).filter(
        day => availability[day]?.length
    );

export { daysWithAvailability };
